import { Component } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { ActivatedRoute } from '@angular/router'
import { SEOService, SharedService } from '@flowaccount/landing'
import { TranslateService } from '@ngx-translate/core'
import { DownloadpdfComponent } from '../downloadpdf-component'

@Component({
  selector: 'app-downloadpdf-desktop',
  templateUrl: './downloadpdf-desktop.component.html',
  styleUrls: ['./downloadpdf-desktop.component.scss', '../downloadpdf-component.scss'],
})
export class DownloadpdfDesktopComponent extends DownloadpdfComponent {
  constructor(
    protected sharedService: SharedService,
    public translate: TranslateService,
    protected activatedRoute: ActivatedRoute,
    protected titleService: Title,
    protected seoService: SEOService,
  ) {
    super(sharedService, translate, activatedRoute, titleService, seoService)
    this.config = {
      init: true,
      direction: 'horizontal',
      slidesPerView: 'auto',
      autoplay: {
        delay: 5000,
        stopOnLastSlide: false,
        disableOnInteraction: true,
        reverseDirection: false,
        waitForTransition: true,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        hideOnClick: false,
        // renderBullet: function (index, className) {
        //   return '<span class="' + className + ' bullet-page-' + (index + 1) + '"></span>';
        // }
      },
    }
  }
}
